import { Alert, Box, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

interface Props {
  text: ReactNode;
}

const CommonNudge = ({ text }: Props) => (
  <Box marginBottom="xsmall">
    <Alert tone="info">
      <Text>{text}</Text>
    </Alert>
  </Box>
);

export default CommonNudge;
